import styled from 'styled-components'

export const StyledAutoHide = styled.div`
  height: 100%;
  width: 100%;
`

export const Fade = styled.div<{ $show: boolean }>`
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
`
